exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips[data-v-2675169c] {\n  padding: 14px 20px;\n  border: 1px dashed #ddd;\n  border-radius: 10px;\n  background-color: #f5fbff;\n  margin-bottom: 20px;\n}\n.width-50[data-v-2675169c] {\n  width: 50px;\n}\n", ""]);

// exports
